import React from 'react'
import type { Icon } from 'shared/utils'

const FaqBurger = (props: Icon) => {
    const {
        color = 'black',
        width = 199,
        height = 154,
        className = 'faq-burger'
    } = props
    return (
        <svg width={width} height={height} fill={color} className={className}>
            <g fillRule="evenodd" opacity={0.2}>
                <path d="M11.137 123.07h13.819l19.142 7.44a52.788 52.788 0 0 0 26.872 3.01l70.311-10.45h46.406v10.044c0 5.947-6.187 10.662-13.818 10.662H24.956c-7.631 0-13.819-4.715-13.819-10.662V123.07zm-9.281 10.044c0 11.072 10.313 19.887 23.1 19.887h149.119c12.787 0 23.1-9.022 23.1-19.887v-19.268H1.856v19.268zm6.185-24.592h182.887c4.33 0 8.04-3.8 8.04-8.445 0-4.644-3.71-8.444-8.04-8.444H8.04c-4.536 0-8.041 3.8-8.041 8.444 0 4.645 3.711 8.445 8.041 8.445M163.501 56A5.5 5.5 0 0 0 169 50.5a5.5 5.5 0 1 0-5.499 5.5M67.5 35a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m-34 33a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m64-6a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11" />
                <path d="M28.075 33.684C43.557 18.185 66.677 9.92 97.435 9.3h4.336c4.196.085 8.245.329 12.165.703a5.324 5.324 0 0 0-.812 2.81 5.37 5.37 0 0 0 5.368 5.373 5.37 5.37 0 0 0 5.367-5.373c0-.55-.107-1.07-.26-1.568 20.03 3.335 35.923 10.87 47.326 22.44 18.992 19.012 18.786 41.95 18.786 42.983 0 .62-.413 1.034-1.033 1.034H144.42a5.39 5.39 0 0 0 .083-.827 5.37 5.37 0 0 0-5.367-5.373 5.37 5.37 0 0 0-5.367 5.373c0 .283.04.554.082.827H10.322c-.62 0-1.033-.414-1.033-1.034 0-1.033 0-23.971 18.786-42.983M10.322 87h178.356C194.252 87 199 82.454 199 76.667c0-1.033.206-27.69-21.469-49.596C160.397 9.713 135.006.62 102.184 0h-5.161c-33.03.62-58.42 9.713-75.554 27.071C0 48.976 0 75.634 0 76.667 0 82.247 4.748 87 10.322 87" />
            </g>
        </svg>
    )
}

export { FaqBurger }
